export const skeleton = {
  colorScheme: {
    light: {
      // background: '{surface.100}',
      // color: '{neutral.900}',
      // borderColor: '#5B5F69',
      animation: {
        background: '#ededed',
      },
    },
    dark: {
      // animation: {
      //   background: '#305675',
      // },
    },
  },
};
